import Image from 'next/image';
import classNames from 'classnames';

const WingsCard = ({
  first,
  second,
  third,
  fourth,
}: {
  first?: string;
  second: string;
  third?: string;
  fourth?: string;
}) => {
  return (
    <div className="border border-[#D0D0D0] rounded-xl">
      <div className="py-2 flex items-center">
        {first && (
          <div
            className={classNames(
              'text-gray-600 font-semibold px-2 py-1 text-sm rounded-full h-8 justify-center items-center flex flex-col',
              {
                'basis-20 shrink-0': third || fourth,
                grow: !third && !fourth,
              }
            )}
          >
            {first}
            <span className="text-copper text-xs">★★★★★</span>
          </div>
        )}
        <div className="flex gap-1 grow justify-center items-center border-l border-r border-[#D0D0D0] h-8">
          <Image
            width={14}
            height={26}
            src={'/left-wing.svg'}
            alt="left-wing"
          />
          <p
            className={classNames('text-base text-center font-bold', {
              'text-base':
                second.length < 18 &&
                (first && first.length ? first.length : 0) < 18,
              'text-sm':
                second.length > 18 ||
                (first && first.length ? first.length : 0) > 18,
            })}
          >
            {second}
          </p>
          <Image
            width={14}
            height={26}
            src={'/right-wing.svg'}
            alt="right-wing"
          />
        </div>
        {(third || fourth) && (
          <div className="flex gap-4 justify-center basis-20 shrink-0 text-sm">
            <div className="flex flex-col items-center">
              <span className="h-5 font-semibold">{third}</span>
              <span className="text-copper">{fourth}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default WingsCard;
